import { render, staticRenderFns } from "./Consumibles.vue?vue&type=template&id=665a028a&scoped=true&"
import script from "./Consumibles.vue?vue&type=script&lang=js&"
export * from "./Consumibles.vue?vue&type=script&lang=js&"
import style0 from "./Consumibles.vue?vue&type=style&index=0&id=665a028a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665a028a",
  null
  
)

export default component.exports